export const QUERY_KEYS = {
  INVOICE: 'INVOICE',
} as const;
